import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, IconButton, Paper, Stack, TextField, Tooltip } from '@mui/material';
import { useController, useFormContext } from 'react-hook-form';
import { ProductVideoAsset } from 'store/api/pages-api/pages-api-types';

import { styles } from './product-video.styles';

type VideoAssetProps = {
  onDeleteButton?: () => void;
  data: ProductVideoAsset;
  prefix?: string;
  assetIdx?: number;
};

const ProductVideo = ({
  assetIdx,
  data,
  onDeleteButton,
  prefix,
}: VideoAssetProps) => {
  const { control } = useFormContext();
  const textField = useController({
    control,
    name: `${prefix}${assetIdx}.file_data.text` as any,
  });

  return (
    <Paper elevation={0} sx={styles.container}>
      <Box sx={styles.header}>
        <Box sx={styles.dragHandle}>
          <DragIndicatorIcon fontSize="small" />
        </Box>
        <Tooltip title="Remove">
          <IconButton color="error" onClick={onDeleteButton} size="small">
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      <Stack spacing={1.5} sx={styles.stack}>
        <Box
          component="video"
          controls
          muted
          src={data.url || data.preview}
          sx={{
            width: '100%',
            height: 170,
            borderRadius: 1,
            bgcolor: '#000',
            flexShrink: 0,
          }}
        >
          <track kind="captions" label="english_captions" src="" srcLang="en" />
          Your browser does not support HTML5 video.
        </Box>

        <TextField
          fullWidth
          label="Text for video"
          multiline
          placeholder="Enter text for video"
          size="small"
          sx={styles.textField}
          {...textField.field}
          error={textField.fieldState.invalid}
          helperText={textField.fieldState.error?.message}
        />
      </Stack>
    </Paper>
  );
};

export { ProductVideo };
